import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { ChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelFeedAutoComplete } from 'views/knowledge/channels/components/ChannelFeedAutoComplete';
import { IAdvFilterPickerProps } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const ChannelPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel, onError } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<ChannelAutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <ChannelFeedAutoComplete
                    autoFocus
                    multiSelect={multiSelect}
                    placeholder={filter.placeholder ?? t(`AdvFilter.Picker.Channel.Placeholder${multiSelect ? "_multi" : ""}`)}
                    color="warning"
                    selectedItems={selected}
                    onChange={(items) => setSelected(items)}
                    onApply={handleApply}
                    onCancel={onCancel}
                    onError={onError}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
